module.exports = __webpack_public_path__ + "img/barbados.122861b8.svg";